module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQ0lEQVQY02MICgpaD8QbCGEGILGMWIVTiFXYQqzCdGIVmhOl8P///yDF/cQqNCVKIZLifoIKkTSYQz3YAg06UDivBwBLtawvNrYbVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./es6/admin-common-js/legacy/vendor/facebox/bl.png
// module id = 576
// module chunks = 7 8 9 10